import React, { useState } from "react";
import {
  AppBar,
  Avatar,
  Box,
  Divider,
  Fade,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { logout } from "../../services/authService";
import EmailIcon from "@mui/icons-material/Email";
import LogoutIcon from "@mui/icons-material/Logout";
import { useEffect } from "react";
import LogoutDialog from "../logoutDialog/LogoutDialog";

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [logoutOpen, setLogoutOpen] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const menuOpen = Boolean(anchorEl);

const handleLogout = () => {
  // ✅ Local clear kar do
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("accounts");
  localStorage.removeItem("twitter_accounts");
 
  setLogoutOpen(false);
  handleMenuClose();
 

  logout();

  window.location.href = "/";
};
  useEffect(() => {
    try {
      const userData = localStorage.getItem("user");
      if (userData) {
        const user = JSON.parse(userData);
        if (user.email) {
          setUserEmail(user.email);
        }
      }
    } catch (error) {
      console.error("Error retrieving user data:", error);
    }
  }, []);
  return (
    <>
      <LogoutDialog
        open={logoutOpen}
        onClose={() => setLogoutOpen(false)}
        onConfirm={handleLogout}
      />
      <AppBar
        position="fixed"
        elevation={2}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "#F3F3EE",
          color: "text.primary",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between", height: 48 }}>
          {/* Logo */}
          <Typography
            variant="h6"
            noWrap
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: 600,
              letterSpacing: "0.5px",
              fontSize: { xs: "1.1rem", sm: "1.4rem" },
            }}
          >
            <div
              className="logo-container"
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "0.6rem",
              }}
            >
              <img
                src="/images/Buzly.png"
                alt="Buzly Logo"
                className="buzly-logo"
                style={{
                  height: "1.5em",
                  marginRight: "0.1em",
                  verticalAlign: "middle",
                }}
              />
              <span style={{ fontWeight: 600 }}>uzzly</span>
            </div>
          </Typography>

          {/* Right Side */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: 1, sm: 2 },
            }}
          >
            <Tooltip
              title="Account settings"
              arrow
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 600 }}
            >
              <Avatar
                onClick={handleMenuOpen}
                sx={{
                  width: 36,
                  height: 36,
                  bgcolor: "#E8E8E3",
                  color: "#13343B",
                  fontWeight: "bold",
                  cursor: "pointer",
                  border: "2px solid rgba(255,255,255,0.8)",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                  },
                }}
              >
                {userEmail?.charAt(0).toUpperCase()}
              </Avatar>
            </Tooltip>

            {/* Menu */}
            <Menu
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleMenuClose}
              TransitionComponent={Fade}
              PaperProps={{
                elevation: 3,
                sx: {
                  borderRadius: 2,
                  minWidth: 250,
                  overflow: "visible",
                  mt: 1.5,
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <Box sx={{ px: 2, py: 1.5, bgcolor: "#f5f5f5" }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  User Profile
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  <EmailIcon fontSize="small" sx={{ color: "#4D99A3" }} />
                  {userEmail}
                </Typography>
              </Box>
              <Divider />

              <MenuItem onClick={() => setLogoutOpen(true)} sx={{ py: 1.5 }}>
                <LogoutIcon sx={{ mr: 2, mb: 2, color: "#4D99A3" }} />
                <Typography variant="body2">Logout</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
